



















































































import { defineComponent, ref, Ref, computed, watch, PropType } from '@vue/composition-api'
import { Modal, Input } from '@/components/general'
import PayrollService from '@/services/payroll/PayrollService'
import { PayrollLunchDay } from '@/models/payroll/PayrollTypes'
import { alerts, dateLibs } from '@/utils'

export default defineComponent({
  name: 'ModalRefreshment',
  components: {
    Modal,
    Input
  },
  props: {
    visible: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    employeeId: {
      type: [Number, String] as PropType<number|string|null>,
      default: null
    },
    employeeName: {
      type: String as PropType<string>,
      default: ''
    },
    year: {
      type: Number as PropType<number>,
      required: true
    },
    month: {
      type: Number as PropType<number>,
      required: true
    },
    fortnight: {
      type: Number as PropType<number>,
      required: true
    },
    hide: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const saving = ref(false)
    const days: Ref<PayrollLunchDay[]> = ref([])

    const title = computed(() => {
      const name = props.employeeName ? ` - ${props.employeeName}` : ''
      return `Refrigerio quincenal${name}`
    })

    const snackDaysTotal = computed(() => {
      return days.value.reduce((acc, day) => acc + (Number(day.amount_lunch) || 0), 0)
    })

    const refreshmentTotal = computed(() => {
      return days.value.reduce((acc, day) => acc + (Number(day.total) || 0), 0)
    })

    const fields = [
      { key: 'date', label: 'Fecha' },
      { key: 'source_label', label: 'Origen' },
      { key: 'amount_lunch', label: 'Cantidad' },
      { key: 'price_lunch', label: 'Valor diario' },
      { key: 'total', label: 'Importe' }
    ]

    const formatDate = (value: string) => dateLibs.formatDateOfApi(value)

    const rowClass = (item: PayrollLunchDay) => {
      return item.has_record ? '' : 'table-secondary text-muted'
    }

    const recalc = (item: PayrollLunchDay) => {
      const amount = Number(item.amount_lunch) || 0
      const price = Number(item.price_lunch) || 0
      item.amount_lunch = amount
      item.price_lunch = price
      item.total = Number((amount * price).toFixed(2))
    }

    const loadDays = async () => {
      if (!props.employeeId) {
        return
      }
      loading.value = true
      try {
        const result = await PayrollService.getLunchDays(
          props.employeeId,
          props.year,
          props.month,
          props.fortnight
        )
        days.value = result.map(day => ({
          ...day,
          amount_lunch: Number(day.amount_lunch) || 0,
          price_lunch: Number(day.price_lunch) || 0,
          total: Number(day.total) || Number(((Number(day.amount_lunch) || 0) * (Number(day.price_lunch) || 0)).toFixed(2))
        }))
      } catch (e) {
        alerts.error('No se pudo cargar el refrigerio del empleado')
      }
      loading.value = false
    }

    watch(() => props.visible, (visible) => {
      if (visible) {
        loadDays()
      }
    })

    const save = async () => {
      if (!props.employeeId) {
        return
      }
      saving.value = true
      try {
        const result = await PayrollService.updateLunchDays({
          employee_id: props.employeeId,
          year: props.year,
          month: props.month,
          fortnight: props.fortnight,
          days: days.value
            .filter(day => day.has_record && day.item_id)
            .map(day => ({
              date: day.date,
              source: day.source,
              item_id: day.item_id,
              amount_lunch: Number(day.amount_lunch) || 0,
              price_lunch: Number(day.price_lunch) || 0,
              has_record: true,
              source_label: day.source_label,
              total: Number(day.total) || 0
            }))
        })
        emit('saved', {
          snackDays: result.snackDays,
          refreshment: result.refreshment
        })
        alerts.success()
        props.hide()
      } catch (e) {
        alerts.error('No se pudo guardar el refrigerio')
      }
      saving.value = false
    }

    return {
      loading,
      saving,
      days,
      fields,
      title,
      snackDaysTotal,
      refreshmentTotal,
      formatDate,
      recalc,
      rowClass,
      save
    }
  }
})
